import { CircleInfoIcon } from "@xola/icons";
import { Tooltip } from "@xola/ui-kit";
import React from "react";
import { AllowedPrivacy, Experience } from "types";
import {
    isAlwaysPrivateExperience,
    isAlwaysPublicExperience,
    isOptionallyPrivateExperience,
} from "../../../models/Experience";
import { RadioInput } from "../../Common/RadioInput";

interface ProductPrivacySelectorProps {
    experience: Experience;
    onChange: (value: AllowedPrivacy[]) => void;
}

export const ProductPrivacySelector = ({ experience, onChange }: ProductPrivacySelectorProps) => {
    return (
        <div className="space-y-2">
            <div className="text-sm font-bold">
                Public & Private Experiences
                <Tooltip
                    content="This gives you or your customers the option to decide whether or not to book the entire event during the checkout
             / back office booking process. If private booking is selected, only one booking is allowed per timeslot."
                >
                    <CircleInfoIcon className="ml-1" />
                </Tooltip>
            </div>

            <div className="items-center space-y-1.5">
                <RadioInput
                    checked={isAlwaysPublicExperience(experience)}
                    name="allowedPrivacies"
                    className="!items-start"
                    classNames={{ input: "mt-1 mr-2" }}
                    onChange={() => onChange([AllowedPrivacy.PUBLIC])}
                >
                    Public Experience:
                    <span className="ml-1 text-gray-darker">Different groups may attend the same event.</span>
                </RadioInput>
                <RadioInput
                    checked={isAlwaysPrivateExperience(experience)}
                    name="allowedPrivacies"
                    className="!items-start"
                    classNames={{ input: "mt-1 mr-2" }}
                    onChange={() => onChange([AllowedPrivacy.PRIVATE])}
                >
                    Private Experience:
                    <span className="ml-1 text-gray-darker">Only one group may attend the event.</span>
                </RadioInput>
                <RadioInput
                    checked={isOptionallyPrivateExperience(experience)}
                    name="allowedPrivacies"
                    className="!items-start"
                    classNames={{ input: "mt-1 mr-2" }}
                    onChange={() => onChange([AllowedPrivacy.PUBLIC, AllowedPrivacy.PRIVATE])}
                >
                    Public & Private Experience:
                    <span className="ml-1 text-gray-darker">
                        A group may electively choose a private or shared experience at the time of purchase.
                    </span>
                </RadioInput>
            </div>
        </div>
    );
};
